/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Board_Col_ResponsesInputs */

const en_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responses`)
};

const de_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten`)
};

const fr_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponses`)
};

const es_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas`)
};

const it_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposte`)
};

const nl_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reacties`)
};

const pl_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiedzi`)
};

const fi_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastaukset`)
};

const da_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svar`)
};

const sv_analytics_board_col_responses = /** @type {(inputs: Analytics_Board_Col_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svar`)
};

/**
* | output |
* | --- |
* | "Responses" |
*
* @param {Analytics_Board_Col_ResponsesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_board_col_responses = /** @type {((inputs?: Analytics_Board_Col_ResponsesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Board_Col_ResponsesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_board_col_responses(inputs)
	if (locale === "fr") return fr_analytics_board_col_responses(inputs)
	if (locale === "es") return es_analytics_board_col_responses(inputs)
	if (locale === "it") return it_analytics_board_col_responses(inputs)
	if (locale === "nl") return nl_analytics_board_col_responses(inputs)
	if (locale === "pl") return pl_analytics_board_col_responses(inputs)
	if (locale === "fi") return fi_analytics_board_col_responses(inputs)
	if (locale === "da") return da_analytics_board_col_responses(inputs)
	if (locale === "sv") return sv_analytics_board_col_responses(inputs)
	return en_analytics_board_col_responses(inputs)
});